import { render, staticRenderFns } from "./CreateRetentionRule.vue?vue&type=template&id=03913552&"
import script from "./CreateRetentionRule.vue?vue&type=script&lang=js&"
export * from "./CreateRetentionRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports